"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AsyncDataAccessor {
    constructor(getter, setter) {
        this.getter = getter;
        this.setter = setter;
    }
    async setInt(context, key, value) {
        return this.setter(context, key, value === undefined ? value : value.toString());
    }
    async getInt(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new TypeError('AsyncDataAccessor: Missing value for key: ' + key);
        }
        const intValue = Number.parseInt(data);
        if (AsyncDataAccessor.INT_REGEX.test(data) === false || Number.isNaN(intValue)) {
            throw new TypeError('AsyncDataAccessor: Value isn\'t int value: ' + data);
        }
        return intValue;
    }
    async setString(context, key, value) {
        return this.setter(context, key, value);
    }
    async getString(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new TypeError('AsyncDataAccessor: Missing value for key: ' + key);
        }
        return data;
    }
    async getStringOrNull(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        return data;
    }
    async getIntOrNull(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const intValue = Number.parseInt(data);
        if (AsyncDataAccessor.INT_REGEX.test(data) === false || Number.isNaN(intValue)) {
            return null;
        }
        return intValue;
    }
    async setFloat(context, key, value) {
        return this.setter(context, key, value === undefined ? value : value.toString());
    }
    async getFloat(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new TypeError('AsyncDataAccessor: Missing value for key: ' + key);
        }
        const floatValue = Number.parseFloat(data);
        if (AsyncDataAccessor.FLOAT_REGEX.test(data) === false || Number.isNaN(floatValue)) {
            throw new TypeError('AsyncDataAccessor: Value isn\'t float value: ' + data);
        }
        return floatValue;
    }
    async getFloatOrNull(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const floatValue = Number.parseFloat(data);
        if (AsyncDataAccessor.FLOAT_REGEX.test(data) === false || Number.isNaN(floatValue)) {
            return null;
        }
        return floatValue;
    }
    async setDate(context, key, value) {
        return this.setter(context, key, value.toString());
    }
    async getDate(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new TypeError('AsyncDataAccessor: Missing value for key: ' + key);
        }
        const dateValue = new Date(data);
        if (Number.isNaN(dateValue.getTime())) {
            throw new TypeError('AsyncDataAccessor: Value isn\'t date value: ' + data);
        }
        return dateValue;
    }
    async getDateOrNull(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const dateValue = new Date(data);
        if (Number.isNaN(dateValue.getTime())) {
            return null;
        }
        return dateValue;
    }
    async setJson(context, key, value, stringify = true) {
        let finalValue = value;
        if (value !== undefined && stringify) {
            finalValue = JSON.stringify(value);
        }
        return this.setter(context, key, finalValue);
    }
    async getJson(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new TypeError('AsyncDataAccessor: Missing value for key: ' + key);
        }
        try {
            return JSON.parse(data);
            // intentionally catch all exceptions to allow default value to support recovery
        }
        catch (e) {
            if (defaultValue !== undefined) {
                return defaultValue;
            }
            throw e;
        }
    }
    async getJsonOrNull(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        try {
            return JSON.parse(data);
            // intentionally catch all exceptions to allow default value to support recovery
        }
        catch (e) {
            if (defaultValue !== undefined) {
                return defaultValue;
            }
            return null;
        }
    }
    async getBool(context, key, defaultValue) {
        const data = await this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return false;
        }
        return data.toLowerCase() !== 'false' && data !== '0';
    }
    async setBool(context, key, value) {
        return this.setter(context, key, value.toString());
    }
    async has(context, key) {
        const data = await this.getter(context, key);
        return data !== undefined;
    }
}
AsyncDataAccessor.INT_REGEX = new RegExp(/^-?\d+$/);
AsyncDataAccessor.FLOAT_REGEX = new RegExp(/^-?\d+(?:\.\d+)?$/);
exports.default = AsyncDataAccessor;
//# sourceMappingURL=AsyncDataAccessor.js.map